import type { SagaIterator } from 'redux-saga';

export function* watchAuthActions(): SagaIterator {
  // Auth-related cart synchronization is handled in CartSyncBridge.
}
